import React from 'react'
import { BreachEvent } from '@news-mono/web-common'
import { MessageBanner } from '../../../../../banners/MessageBanner/MessageBanner'
import { BreachDiscountContent } from './BreachDiscountContent'
import { SimpleTextBanner } from '../../../../../banners/SimpleTextBanner/SimpleTextBanner'
import { TextLink } from '../../../../../typography/TextLink/TextLink'

export interface BreachDiscountNotificationProps {
    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
}

export function BreachDiscountNotification({
    articleId,
    breachDeal,
    breachCreativeName,
    onEvent,
}: BreachDiscountNotificationProps) {
    return (
        <div data-testid="BreachScreen">
            <MessageBanner
                icon="subscriber"
                connector="solid-arrow"
                onEvent={onEvent}
            >
                <p>
                    This article is available to subscribers who have digital
                    access included in their subscription.
                </p>
            </MessageBanner>

            <BreachDiscountContent
                breachDeal={breachDeal}
                articleId={articleId}
                breachCreativeName={breachCreativeName}
                onEvent={onEvent}
                title="Get 50% off"
                message={<p>your digital subscription for 8 weeks*</p>}
                cta="Subscribe now"
                terms={
                    <p>
                        *Valid for new subscribers only.
                        {breachDeal === 'GOVAN50'
                            ? 'Offer ends 20 February 2021.'
                            : ''}
                        <br />
                        T&Cs apply
                    </p>
                }
                subscriptionPackages={[
                    {
                        articleId: articleId,
                        breachCreativeName: breachCreativeName,
                        breachDeal: breachDeal,
                        onEvent: onEvent,
                        packageTheme: 'red',
                        packagePath: 'subscribe/new',
                        pretitle: 'Digital',
                        heading: 'Everyday Digital',
                        price: '50c per day',
                        originalPrice: '$1 per day',
                        priceQualifier: 'for 8 weeks*',
                        packageType: 'digital',
                        ribbonTitle: '50% off',
                        offerCode: breachDeal,
                    },
                    {
                        articleId: articleId,
                        breachCreativeName: breachCreativeName,
                        breachDeal: 'WKEND+DIG',
                        onEvent: onEvent,
                        pretitle: 'Digital & Print',
                        heading: 'Weekend Papers + Everyday Digital',
                        price: '$9 per week',
                        packagePath: 'subscribenow/sat-sun+digital',
                        packageType: 'digitalprint',
                    },
                ]}
            />

            <SimpleTextBanner>
                <p>
                    All subscriptions include exclusive subscriber offers,
                    events and giveaways with West Rewards, our subscriber
                    rewards program.
                </p>
                <p>
                    Need Help?{' '}
                    <TextLink href="tel:1800 811 855">1800 811 855</TextLink>.
                </p>
            </SimpleTextBanner>
        </div>
    )
}
